import axios from "axios";
import urlconfig, { currentApi, staginApi } from "../_config.js";
const VERSION = "v1";
const CHAT_GPT_TOKEN = "05950b21-9814-4621-94c7-25d710ce0819";
const CHAT_GPT_PROD_ENDPOINT =
  "https://survey-chat-v2.innerlogic-api.com/api/v1/survey-ai/generate-chat-gpt-response";
const CHAT_GPT_STG_ENDPOINT =
  "https://stg-survey-chat-v2.innerlogic-api.com/api/v1/survey-ai/generate-chat-gpt-response";
const CHAT_GPT_API_ENDPOINT =
  currentApi === staginApi
    ? CHAT_GPT_STG_ENDPOINT
    : CHAT_GPT_PROD_ENDPOINT;

export const GET_START_SURVEY = (payload) =>
  axios.get(
    `${urlconfig.surveyapi}/${VERSION}/start-survey/${payload ? payload : ""}`
  );

export const GET_CULTURE_QUESTIONS = (payload) =>
  axios.get(
    `${urlconfig.surveyapi}/${VERSION}/culture-questions/${
      payload ? payload : ""
    }`
  );

export const GET_MOOD_QUESTIONS = (payload) =>
  axios.get(
    `${urlconfig.surveyapi}/${VERSION}/mood-questions/${payload ? payload : ""}`
  );

export const GET_LEADERSHIP_QUESTIONS = (payload) =>
  axios.get(
    `${urlconfig.surveyapi}/${VERSION}/leadership-questions/${
      payload ? payload : ""
    }`
  );

export const GET_PERSONALITY_QUESTIONS = (payload) =>
  axios.get(
    `${urlconfig.surveyapi}/${VERSION}/personality-questions/${
      payload ? payload : ""
    }`
  );

export const GET_PREVIOUS_RESPONSE = (payload) =>
  axios.get(
    `${urlconfig.surveyapi}/${VERSION}/previous-response/${
      payload ? payload : ""
    }`
  );

export const POST_ANSWER = (answers) =>
  axios.post(`${urlconfig.surveyapi}/${VERSION}/survey-response/`, answers);

export const START_PERSONALITY_ANSWER = (payload) => {
  return axios.post(
    `${urlconfig.surveyapi}/${VERSION}/personality-updates/`,
    payload
  );
};
export const UPDATE_PERSONALITY_ANSWER = (token, payload) => {
  return axios.patch(
    `${urlconfig.surveyapi}/${VERSION}/personality-updates/${token}/`,
    payload
  );
};

export const GET_PERSONALITY_ANSWER = (payload) =>
  axios.get(
    `${urlconfig.surveyapi}/${VERSION}/personality-updates/${
      payload ? `${payload}` : ""
    }`
  );

export const GET_CULTURE = () => {
  return;
};

export const GET_MOODS = () => {
  return;
};

export const GET_BRIEF_SURVEY = (payload) =>
  axios.get(
    `${urlconfig.surveyapi}/${VERSION}/brief-token/${payload ? payload : ""}`
  );

export const UPDATE_BRIEF_RESPONSE = (payload) => {
  return axios.patch(
    `${urlconfig.surveyapi}/${VERSION}/brief-token/${payload?.id}/${
      payload?.query ? payload?.query : ""
    }`,
    payload
  );
};

export const POST_BRIEF_RESPONSE = (answers) =>
  axios.post(`${urlconfig.surveyapi}/${VERSION}/brief-response/`, answers);

export const GET_BRIEF_MODULAR_QUESTIONS = (payload) =>
  axios.get(
    `${urlconfig.surveyapi}/${VERSION}/brief-component-question/${
      payload ? payload : ""
    }`
  );

export const GET_CHAT_GPT_SUMMARY = (payload) => {
  return axios.post(
    CHAT_GPT_API_ENDPOINT,
    {
      ...payload,
      token: CHAT_GPT_TOKEN,
    }
  );
};

export const GET_CHAT_GPT_SUMMARY_MULTI = (payload) => {
  return axios.post(
    `${urlconfig.surveyapi}/${VERSION}/chat-gpt-summary-multi/`,
    payload
  );
};

export const POST_MARKETING_ROI = (marketingRoi) =>
  axios.post(
    `${urlconfig.surveyapi}/${VERSION}/marketing-response/`,
    marketingRoi
  );

export const START_TASK_TEMPLATE_SURVEY = (payload) =>
  axios.get(
    `${urlconfig.surveyapi}/${VERSION}/outcome-task/${payload ? payload : ""}`
  );

export const SUBMIT_TASK_TEMPLATE_SURVEY = (payload) =>
  axios.post(
    `${urlconfig.surveyapi}/${VERSION}/outcome-task-user-response/`,
    payload
  );

// ----- Action Planning (token flows) -----
// Use configured organization base to hit the real API (not mocks)
export const AP_GET_MY_EVENTS = (token) =>
  axios.get(`${urlconfig.appapi}/v1/action-plan-v2/manager/my_events/?token=${encodeURIComponent(token)}`);

export const AP_GET_MY_ACTIONS = (token) =>
  axios.get(`${urlconfig.appapi}/v1/action-plan-v2/manager/my_actions/?token=${encodeURIComponent(token)}`);

// Per v2.1 spec, submit goes through submit-response with event id as query param
export const AP_PATCH_EVENT_RESPONSE = (eventId, token, response_data) =>
  axios.patch(
    `${urlconfig.appapi}/v1/action-plan-v2/manager/submit-response/?token=${encodeURIComponent(token)}&event=${encodeURIComponent(eventId)}`,
    { response_data }
  );

// Submit a check-in for a specific action (event-scoped)
export const AP_PATCH_ACTION_CHECKIN = (eventId, actionId, token, checkinData) =>
  axios.patch(
    `${urlconfig.appapi}/v1/action-plan-v2/events/${encodeURIComponent(eventId)}/actions/${encodeURIComponent(actionId)}/submit-checkin/?token=${encodeURIComponent(token)}`,
    checkinData
  );

// Submit a direct check-in update for any action
export const AP_PATCH_DIRECT_CHECKIN = (actionId, token, checkinData) =>
  axios.patch(
    `${urlconfig.appapi}/v1/action-plan-v2/manager/submit-checkin/?token=${encodeURIComponent(token)}&action_id=${encodeURIComponent(actionId)}`,
    checkinData
  );

// Get available status options for check-in dropdowns
export const AP_GET_STATUS_OPTIONS = (token) =>
  axios.get(`${urlconfig.appapi}/v1/action-plan-v2/manager/status-options/?token=${encodeURIComponent(token)}`);

export const AP_GET_MY_REPORTS = (token) =>
  axios.get(`${urlconfig.appapi}/v1/action-plan-v2/manager/my_reports/?token=${encodeURIComponent(token)}`);

export const AP_GET_REPORT_PDF = (token, trackingCode) =>
  axios.get(
    `${urlconfig.appapi}/v1/action-plan-v2/manager/get-pdf/?tracking_code=${encodeURIComponent(trackingCode)}`,
    {
      responseType: "blob",
      headers: {
        Authorization: `Token ${encodeURIComponent(token)}`,
      },
    }
  );

